import { Typography, Table, Spin, Button } from "antd"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { IColumnType } from "../../types"
import formatStringToNumber from "../../utils/formatStringToNumber"
import { safeConvertFixed } from "../../utils/safeConvertFixed"
import { renderTotal } from "../../utils/totalSign"   // tog'a #1952: minus faqat qarzlarda

export interface ITableSummaryProps {
  query?: any
  queryVariables?: any
  summaryKeys: string[]
  summaryKeyRenders?: any
  // tog'a 1156 (2026-09-04): JAMI katagini ustun bo'yicha maxsus chizish (masalan qarz → «Долг X / Аванс X», minus o'rniga)
  summaryCellRenders?: Record<string, (raw: number) => React.ReactNode>
  columns: IColumnType[]
  data: any
  removeFirst?: boolean
  isGroup?: boolean
  name?: string
  allData?: any
  totalOutcome?: any
}

export default function TableSummary({
  query,
  summaryKeys,
  columns,
  summaryKeyRenders,
  summaryCellRenders,
  data,
  isGroup,
  queryVariables,
  removeFirst,
  name,
  allData,
  totalOutcome,
}: ITableSummaryProps) {
  const { t } = useTranslation()
  const [summaryData, setSummaryData] = useState({
    data: data,
    isTotal: false,
  })

  useEffect(() => {
    data &&
      !query &&
      setSummaryData({
        data: allData ? allData : data,
        isTotal: false,
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, allData])

  function calculateTotalData(key: any, index: number) {
    if (totalOutcome && typeof totalOutcome === "object") {
      const matchedKey = Object.keys(totalOutcome).find(
        (k) => k.toLowerCase() === key.toLowerCase()
      )
      if (
        matchedKey &&
        totalOutcome[matchedKey] !== undefined &&
        totalOutcome[matchedKey] !== null
      ) {
        if (summaryCellRenders?.[key]) return summaryCellRenders[key](Number(totalOutcome[matchedKey]) || 0)
        return renderTotal(key, totalOutcome[matchedKey])   // tog'a #1952
      }
    }

    const rawSum = summaryData?.data?.reduce((a: number, b: any) => {
      let val = 0
      if (summaryKeyRenders?.[key]) {
        val = Number(summaryKeyRenders[key](b, index)) || 0
      } else {
        val = Number(b?.[key]) || 0
      }
      return a + val
    }, 0)
    if (summaryCellRenders?.[key]) return summaryCellRenders[key](Number(rawSum) || 0)
    return renderTotal(key, rawSum)   // tog'a #1952
  }

  // Birinchi summary ustunining o'rni — «Итого» yorlig'i shundan bitta chapga tushadi
  const rawIdx = columns.findIndex(
    (x) => x.dataIndex?.toString() === summaryKeys[0]
  )
  const firstIdx = rawIdx < 0 ? 0 : rawIdx

  const totalCount =
    totalOutcome?.totalRecords ??
    totalOutcome?.id ??
    totalOutcome?.Id ??
    (summaryData.isTotal ? t("all") : data?.length)

  return (
    <Table.Summary.Row className="table-summary-row">
      {!removeFirst &&
        columns
          .slice(0, firstIdx)
          .map((col, i) => <Table.Summary.Cell key={i} index={i} />)}
      <Table.Summary.Cell index={0} align="center">
        <Spin spinning={false}>
          <Button
            type="link"
            style={{ fontWeight: "bold" }}
          >{`${t("summary")} [${totalCount}]`}</Button>
        </Spin>
      </Table.Summary.Cell>
      {/* audit R2-REP-01 (2026-09-03): «Итого» qiymatlari faqat summaryKeys bo'yicha
          chizilardi. Summary ustunlari QO'SHNI bo'lmasa (Продажи: amount → priceUSD →
          totalPriceUSD) qiymatlar bitta ustun chapga siljib, sotuv summasi «Цена»
          ustunida ko'rinardi. Endi birinchi summary ustunidan boshlab HAR bir ustunga
          katak chiqadi; summary bo'lmagan ustun bo'sh qoladi. */}
      {columns.slice(firstIdx).map((col, i) => {
        const colKey = col.dataIndex?.toString() || ""
        const keyIdx = summaryKeys.indexOf(colKey)
        return (
          <Table.Summary.Cell index={i} key={i} align="center">
            {keyIdx >= 0 && (
              <Typography.Text strong ellipsis type="success">
                {calculateTotalData(colKey, keyIdx)}
              </Typography.Text>
            )}
          </Table.Summary.Cell>
        )
      })}
    </Table.Summary.Row>
  )
}
